// Vendors
import { useEffect, useMemo, useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
// Event Handlers
import { ContractViewerHandlers } from '../handlers/contract-viewer.handlers';
// Types
import type { ContractViewerHookType } from './types/contract-viewer.hook.type';
import type { ContractViewerMethodsHandlersType } from '../handlers/types/contract-viewer.handlers.type';
import type { ContractViewerComponentType } from '../types/contract-viewer.component.type';
// Utilities
import { createObjectUrlFromBlob } from '@openbank/cf-ui-framework';

const useContractViewerHook = (
  pdfUrl: ContractViewerComponentType['pdfUrl']
): ContractViewerHookType => {
  const [landscape, setLandscape] = useState<boolean>(false);

  const { showBoundary: setError } = useErrorBoundary();

  const {
    handleWatchMobileOrientationChangeEvent,
    ...handlers
  }: ContractViewerMethodsHandlersType = useMemo<ReturnType<typeof ContractViewerHandlers>>(
    () => ContractViewerHandlers({ setLandscape, setError }),
    []
  );

  const memorizedPdfUrl = useMemo(() => {
    return pdfUrl ? createObjectUrlFromBlob(pdfUrl) : '';
  }, [pdfUrl]);

  useEffect(() => {
    handleWatchMobileOrientationChangeEvent();
  }, []);

  return {
    ...handlers,
    landscape,
    memorizedPdfUrl,
  };
};

export { useContractViewerHook };
